import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex h-screen w-screen items-center justify-center"
}

import { onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { Toaster } from '@/components/ui/toast'
import MinimizedDocumentsWidget from '@/components/MinimizedDocumentsWidget.vue'
import DocumentViewerWidget from '@/components/DocumentViewerWidget.vue'
import DocumentViewerPanel from '@/components/DocumentViewerPanel.vue'
import HelpCenterWidget from '@/components/HelpCenterWidget.vue'
import HelpCenterPanel from '@/components/HelpCenterPanel.vue'
import VoiceNotesWidget from '@/components/VoiceNotesWidget.vue'
import VoiceNotesPanel from '@/components/VoiceNotesPanel.vue'
import CopilotWidget from '@/components/CopilotWidget.vue'
import CopilotPanel from '@/components/CopilotPanel.vue'
import TasksWidget from '@/components/TasksWidget.vue'
import TasksPanel from '@/components/TasksPanel.vue'

import { useDocumentViewer } from '@/composables/useDocumentViewer'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { locale } = useI18n()
const route = useRoute()
const authStore = useAuthStore()
const { initFromStorage } = useDocumentViewer()

const isReady = computed(() => authStore.initialized)
const isPublicPage = computed(() =>
  route.path.startsWith('/public/') || route.path === '/landing'
)
const showWidgets = computed(() => authStore.user && !isPublicPage.value)
const showHelpCenter = computed(() => authStore.user && !isPublicPage.value)
const showCopilot = computed(() => {
  if (!authStore.user || isPublicPage.value) return false
  const role = authStore.userRole
  if (role === 'superadmin') return true
  if (role !== 'admin' && role !== 'operator') return false
  return authStore.isModuleEnabled('agent')
})
const showVoiceNotes = computed(() => {
  if (!authStore.user || isPublicPage.value) return false
  const role = authStore.userRole
  if (role === 'superadmin') return true
  if (role !== 'admin' && role !== 'operator') return false
  return authStore.isModuleEnabled('voiceNotes')
})
const showTasks = computed(() => {
  if (!authStore.user || isPublicPage.value) return false
  const role = authStore.userRole
  return role === 'superadmin' || role === 'admin' || role === 'operator'
})

onMounted(async () => {
  // Initialize auth state
  await authStore.initializeAuth()

  // Load saved locale
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && (savedLocale === 'es' || savedLocale === 'en')) {
    locale.value = savedLocale
  }

  // Load user's preferred locale if logged in
  if (authStore.user?.language) {
    locale.value = authStore.user.language
  }

  // Restore document viewer from localStorage if a doc was open
  initFromStorage()
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isReady.value)
      ? (_openBlock(), _createBlock(_component_RouterView, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary" }, null, -1)
        ]))])),
    _createVNode(_unref(Toaster)),
    (showWidgets.value)
      ? (_openBlock(), _createBlock(MinimizedDocumentsWidget, { key: 2 }))
      : _createCommentVNode("", true),
    (showWidgets.value)
      ? (_openBlock(), _createBlock(DocumentViewerWidget, { key: 3 }))
      : _createCommentVNode("", true),
    (showWidgets.value)
      ? (_openBlock(), _createBlock(DocumentViewerPanel, { key: 4 }))
      : _createCommentVNode("", true),
    (showVoiceNotes.value)
      ? (_openBlock(), _createBlock(VoiceNotesWidget, { key: 5 }))
      : _createCommentVNode("", true),
    (showVoiceNotes.value)
      ? (_openBlock(), _createBlock(VoiceNotesPanel, { key: 6 }))
      : _createCommentVNode("", true),
    (showTasks.value)
      ? (_openBlock(), _createBlock(TasksWidget, { key: 7 }))
      : _createCommentVNode("", true),
    (showTasks.value)
      ? (_openBlock(), _createBlock(TasksPanel, { key: 8 }))
      : _createCommentVNode("", true),
    (showCopilot.value)
      ? (_openBlock(), _createBlock(CopilotWidget, { key: 9 }))
      : _createCommentVNode("", true),
    (showCopilot.value)
      ? (_openBlock(), _createBlock(CopilotPanel, { key: 10 }))
      : _createCommentVNode("", true),
    (showHelpCenter.value)
      ? (_openBlock(), _createBlock(HelpCenterWidget, { key: 11 }))
      : _createCommentVNode("", true),
    (showHelpCenter.value)
      ? (_openBlock(), _createBlock(HelpCenterPanel, { key: 12 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})